/**
 * Computes the sum of the values in array.
 *
 * @param {Array<number>} array
 * @return {number}
 *
 * @example
 * sum([1, 2, 3, 4]);
 * // return 10
 */
export var sum = function (array) { return array.reduce(function (acc, num) { return acc + num; }, 0); };
//# sourceMappingURL=sum.js.map